import * as types from './constants'

const initialState = {
  refetchCourses: false,
  roles: [],
  rolesCount: [],
  groupsRows: [],
  searchValue: '',
  coursesRows: [],
  isLoading: false,
  curriculumRows: [],
  groupLocations: [],
  courseModule: null,
  groupsModule: null,
  externalReportsModule: null,
  searchByData: true,
  searchByCore: false,
  exportButton: true,
  groupsColumnDefs: [],
  groupsUpdated: false,
  groupsInfoReport: '',
  coursesColumnDefs: [],
  searchByHeader: false,
  coursesUpdated: false,
  externalReportsUpdated: false,
  coursesInfoReport: '',
  curriculumModule: null,
  selectedTab: 'courses',
  selectedTraining: null,
  savedGroupsFilters: [],
  selectedGroupsRole: [],
  savedCoursesFilters: [],
  savedExternalReportsFilters: [],
  selectedCoursesRole: [],
  groupsRowScrollIndex: 0,
  groupsNewFilterName: '',
  focusedGroupsCell: null,
  locationGroupCourses: [],
  categories: [],
  areas: [],
  coursesRowScrollIndex: 0,
  focusedCoursesCell: null,
  coursesNewFilterName: '',
  groupGroupsLocations: [],
  selectedGroupsGroup: null,
  selectedCoursesGroup: null,
  selectedCategories: null,
  selectedCurriculumRole: [],
  exportTrainingButton: false,
  exportExternalReportsButton: false,
  selectedGroupsLocations: [],
  selectedCoursesLocations: [],
  selectedCurriculumGroup: null,
  groupsColumnScrollIndex: null,
  coursesColumnScrollIndex: null,
  selectedGroupsSavedFilter: null,
  selectedCoursesSavedFilter: null,
  groupsFilterOveralyShowing: false,
  coursesFilterOveralyShowing: false,
  externalReportsFilterOveralyShowing: false,
  selectedGroupGroupsLocations: null,
  courseManagerGroupsLocationGroups: [],
  selectedCourseManagerGroupsLocationGroups: null,
  externalReportsRows: [],
  externalReportsColumnDefs: [],
  externalReportsInfoReport: '',
  selectedExternalReportsSavedFilter: null,
  focusedExternalReportsCell: null,
  selectedExternalReportsRole: [],
  selectedExternalReportsGroup: null,
  selectedExternalReportsLocations: [],
  selectedCategories: null,
  selectedExternalReportsFilter: null,
  // selectedGroupGroupsLocations: null,
  externalReportsNewFilterName: '',
  breadcrumbAll: [],
  breadcrumb: [],
  managerId: null,
  selectedCoursesGroups: null,
  selectedGroupsGroups: null,
  selectedExternalReportsGroups: null,
  publicCatalogColumnDefs: [],
  publicCatalogRowData: [],
  publicCatalogLoading: false,
  publicCatalogChartsLoading: false,
  publicCatalogCharts: [],
  publicCatalogDataFetched: false,
  requestsLoading: {},
}

const managerReport = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_MANAGER_REPORT_DATA:
      return initialState
    case types.SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.selectedTab,
      }

    case types.SELECT_GROUP:
      return {
        ...state,
        selectedCoursesGroup: action.group,
      }
    case types.SELECT_CATEGORY:
      return {
        ...state,
        selectedCategories: action.category,
      }
    case types.SELECT_GROUPS_GROUP:
      return {
        ...state,
        selectedGroupsGroup: action.group,
      }
    case types.SELECT_EXTERNAL_REPORTS_GROUP:
      return {
        ...state,
        selectedExternalReportsGroup: action.group,
      }
    case types.SET_GROUP_LOCATIONS:
      return {
        ...state,
        groupLocations: action.locations,
      }
    case types.SET_GROUPS_GROUP_LOCATIONS:
      return {
        ...state,
        groupGroupsLocations: action.locations,
      }
    case types.SET_LOCATION_GROUPS_COURSES:
      return {
        ...state,
        locationGroupCourses: action.locationGroupCourses,
      }

    case types.SET_CATEGORIES:
      return {
        ...state,
        categories: action.categories,
      }
    case types.SET_AREAS:
      return {
        ...state,
        areas: action.areas,
      }
    case types.SELECT_LOCATION:
      return {
        ...state,
        selectedCoursesLocations: action.locations,
      }

    case types.SELECT_EXTERNAL_REPORTS_LOCATION:
      return {
        ...state,
        selectedExternalReportsLocations: action.locations,
      }
    case types.SET_SELECTED_GROUPS_LOCATION_GROUPS_COURSES:
      return {
        ...state,
        selectedGroupGroupsLocations: action.locationGroup,
      }
    case types.SELECT_GROUPS_LOCATION:
      return {
        ...state,
        selectedGroupsLocations: action.locations,
      }
    case types.SET_SELECTED_TRAINING:
      return {
        ...state,
        selectedTraining: action.selectedTraining,
      }
    case types.SET_EXPORT_TRAINING_BUTTON:
      return {
        ...state,
        exportTrainingButton: action.exportTrainingButton,
      }
    case types.SET_EXPORT_EXTERNAL_REPORTS_BUTTON:
      return {
        ...state,
        exportExternalReportsButton: action.exportExternalReportsButton,
      }
    case types.SET_EXPORT_BUTTON:
      return {
        ...state,
        exportButton: action.exportButton,
      }
    case types.SET_COURSE_MODULE:
      return {
        ...state,
        courseModule: action.data,
      }
    case types.SET_GROUPS_MODULE:
      return {
        ...state,
        groupsModule: action.data,
      }
    case types.SET_EXTERNAL_REPORTS_MODULE:
      return {
        ...state,
        externalReportsModule: action.data,
      }
    case types.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.value,
      }
    case types.SET_SEARCH_VALUE_ON_CLICK:
      return {
        ...state,
        searchValueOnClick: action.value,
      }
    case types.SET_SEARCH_BY_DATA:
      return {
        ...state,
        searchByData: action.searchByData,
      }
    case types.SET_SEARCH_BY_HEADER:
      return {
        ...state,
        searchByHeader: action.searchByHeader,
      }

    case types.SET_SEARCH_BY_CORE:
      return {
        ...state,
        searchByCore: action.searchByCore,
      }
    case types.SET_ROWS:
      return {
        ...state,
        coursesRows: action.rows,
      }
    case types.SET_COLUMN_DEFS:
      return {
        ...state,
        coursesColumnDefs: action.columnDefs,
      }
    case types.SET_EXTERNAL_REPORTS_COLUMN_DEFS:
      return {
        ...state,
        externalReportsColumnDefs: action.columnDefs,
      }
    case types.SET_GROUPS_COLUMN_DEFS:
      return {
        ...state,
        groupsColumnDefs: action.columnDefs,
      }
    case types.SET_GROUPS_ROWS:
      return {
        ...state,
        groupsRows: action.rows,
      }
    case types.SET_EXTERNAL_REPORTS_ROWS:
      return {
        ...state,
        externalReportsRows: action.rows,
      }
    case types.SET_COURSE_SELECTED_ROLES:
      return {
        ...state,
        selectedCoursesRole: action.roles,
      }
    case types.SET_GROUPS_SELECTED_ROLES:
      return {
        ...state,
        selectedGroupsRole: action.roles,
      }
    case types.SET_EXTERNAL_REPORTS_SELECTED_ROLES:
      return {
        ...state,
        selectedExternalReportsRole: action.roles,
      }
    case types.SET_COURSE_MANAGER_COURSE_GROUPS:
      return {
        ...state,
        courseManagerGroupsLocationGroups: action.locationGroups,
      }
    case types.SELECT_COURSE_MANAGER_GROUP_LOCATION_GROUPS:
      return {
        ...state,
        selectedCourseManagerGroupsLocationGroups: action.group,
      }
    case types.SET_COURSE_ROW_SCROLL_INDEX:
      return {
        ...state,
        coursesRowScrollIndex: action.value,
      }
    case types.SET_COURSE_COLUMN_SCROLL_INDEX:
      return {
        ...state,
        coursesColumnScrollIndex: action.value,
      }
    case types.SET_GROUP_ROW_SCROLL_INDEX:
      return {
        ...state,
        groupsRowScrollIndex: action.value,
      }
    case types.SET_GROUP_COLUMN_SCROLL_INDEX:
      return {
        ...state,
        groupsColumnScrollIndex: action.value,
      }
    case types.SET_COURSES_FOCUSED_CELL:
      return {
        ...state,
        focusedCoursesCell: action.value,
      }
    case types.SET_EXTERNAL_REPORTS_FOCUSED_CELL:
      return {
        ...state,
        focusedExternalReportsCell: action.value,
      }
    case types.SET_GROUPS_FOCUSED_CELL:
      return {
        ...state,
        focusedGroupsCell: action.value,
      }
    case types.SET_COURSES_UPDATED:
      return {
        ...state,
        coursesUpdated: action.value,
      }
    case types.SET_EXTERNAL_REPORTS_UPDATED:
      return {
        ...state,
        externalReportsUpdated: action.value,
      }
    case types.SET_GROUPS_UPDATED:
      return {
        ...state,
        groupsUpdated: action.value,
      }
    case types.SET_SHOW_COURSES_FILTER_OVERALY:
      return {
        ...state,
        coursesFilterOveralyShowing: action.value,
      }
    case types.SET_SHOW_EXTERNAL_REPORTS_FILTER_OVERALY:
      return {
        ...state,
        externalReportsFilterOveralyShowing: action.value,
      }
    case types.SET_SHOW_GROUPS_FILTER_OVERALY:
      return {
        ...state,
        groupsFilterOveralyShowing: action.value,
      }
    case types.SET_SAVED_FILTERS:
      return {
        ...state,
        savedCoursesFilters: action.savedCoursesFilters,
        savedGroupsFilters: action.savedGroupsFilters,
        savedExternalReportsFilters: action.savedExternalReportsFilters,
      }
    case types.CLEAR_COURSES_FILTER_DATA:
      return {
        ...state,
        refetchCourses: true,
        // courseModule: null,
        // coursesRows: [],
        // coursesColumnDefs: [],
        selectedCoursesRole: [],
        selectedCoursesGroup: null,
        selectedCoursesLocations: [],
        selectedCategories: null,
        selectedCoursesSavedFilter: null,
        coursesNewFilterName: '',
        selectedCoursesGroups: null,
      }

    case types.RESET_REFETCH_MANAGER_REPORTS_COURSES:
      return {
        ...state,
        refetchCourses: false,
      }
    case types.REFETCH_MANAGER_REPORTS_COURSES:
      return {
        ...state,
        refetchCourses: true,
      }
    case types.CLEAR_GROUPS_FILTER_DATA:
      return {
        ...state,
        groupsModule: null,
        groupsRows: [],
        groupsColumnDefs: [],
        selectedGroupsRole: [],
        selectedGroupsGroup: null,
        selectedGroupsLocations: [],
        selectedCategories: null,
        selectedGroupsSavedFilter: null,
        selectedGroupGroupsLocations: null,
        groupsNewFilterName: '',
        selectedGroupsGroups: null,
      }
    case types.CLEAR_EXTERNAL_REPORTS_FILTER_DATA:
      return {
        ...state,
        externalReportsModule: null,
        externalReportsRows: [],
        externalReportsColumnDefs: [],
        selectedExternalReportsRole: [],
        selectedExternalReportsGroup: null,
        selectedExternalReportsLocations: [],
        selectedCategories: null,
        selectedExternalReportsFilter: null,
        // selectedGroupGroupsLocations: null,
        externalReportsNewFilterName: '',
        selectedExternalReportsGroups: null,
      }
    case types.CLEAR_COURSES_DATA:
      return {
        ...state,
        courseModule: null,
        coursesRows: [],
        coursesColumnDefs: [],
      }
    case types.CLEAR_GROUPS_DATA:
      return {
        ...state,
        groupsModule: null,
        groupsRows: [],
        groupsColumnDefs: [],
      }
    case types.CLEAR_EXTERNAL_REPORTS_DATA:
      return {
        ...state,
        externalReportsModule: null,
        externalReportsRows: [],
        externalReportsColumnDefs: [],
      }
    case types.SET_SELECTED_SAVED_FILTER:
      return {
        ...state,
        selectedCoursesSavedFilter: action.value,
      }
    case types.SET_SELECTED_GROUPS_SAVED_FILTER:
      return {
        ...state,
        selectedGroupsSavedFilter: action.value,
      }
    case types.SET_SELECTED_EXTERNAL_REPORTS_SAVED_FILTER:
      return {
        ...state,
        selectedExternalReportsSavedFilter: action.value,
      }
    case types.SET_COURSES_NEW_FILTER_NAME:
      return {
        ...state,
        coursesNewFilterName: action.value,
      }
    case types.SET_GROUPS_NEW_FILTER_NAME:
      return {
        ...state,
        groupsNewFilterName: action.value,
      }
    case types.SET_COURSES_INFO_REPORT:
      return {
        ...state,
        coursesInfoReport: action.value,
      }
    case types.SET_GROUPS_INFO_REPORT:
      return {
        ...state,
        groupsInfoReport: action.value,
      }
    case types.SET_EXTERNAL_REPORTS_INFO_REPORT:
      return {
        ...state,
        externalReportsInfoReport: action.value,
      }
    case types.SET_ROLES:
      return {
        ...state,
        rolesCount: action.rolesCount,
      }
    case types.ADD_TO_BREADCRUMB_ALL:
      return {
        ...state,
        breadcrumbAll: [...state.breadcrumbAll, action.payload],
      }
    case types.ADD_TO_BREADCRUMB:
      return {
        ...state,
        breadcrumb: [...state.breadcrumb, action.payload],
      }
    case types.SET_BREADCRUMB_ALL:
      return {
        ...state,
        breadcrumbAll: action.payload,
      }
    case types.SET_BREADCRUMB:
      return {
        ...state,
        breadcrumb: action.payload,
      }
    case types.SET_MANAGER_ID:
      return {
        ...state,
        managerId: action.payload,
      }
    case types.SELECT_GROUPS:
      return {
        ...state,
        selectedCoursesGroups: action.groups,
      }
    case types.SELECT_GROUPS_GROUPS:
      return {
        ...state,
        selectedGroupsGroups: action.payload,
      }
    case types.SELECT_EXTERNAL_REPORTS_GROUPS:
      return {
        ...state,
        selectedExternalReportsGroups: action.payload,
      }
    case types.SET_PUBLIC_CATALOG_COLUMN_DEFS:
      return {
        ...state,
        publicCatalogColumnDefs: action.payload,
      }
    case types.SET_PUBLIC_CATALOG_ROW_DATA:
      return {
        ...state,
        publicCatalogRowData: action.payload,
      }
    case types.SET_PUBLIC_CATALOG_LOADING:
      return {
        ...state,
        publicCatalogLoading: action.payload,
      }
    case types.SET_PUBLIC_CATALOG_CHARTS_LOADING:
      return {
        ...state,
        publicCatalogChartsLoading: action.payload,
      }
    case types.SET_PUBLIC_CATALOG_CHARTS:
      return {
        ...state,
        publicCatalogCharts: action.payload,
      }

    case types.SET_PUBLIC_CATALOG_DATA_FETCHED:
      return {
        ...state,
        publicCatalogDataFetched: action.payload,
      }
    case types.SET_LOADING:
      return {
        ...state,
        requestsLoading: action.payload,
      }
    default:
      return state
  }
}

export default managerReport
